import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _typeof from "@babel/runtime/helpers/typeof";
function isInArray(arr) {
  var isRequired = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return function isInArrayFn(props, propName, componentName) {
    var prop = props[propName];
    var isValid = arr.includes(prop);
    if (!isValid && isRequired) {
      return new Error("'".concat(prop, "' is not a valid value for the prop '").concat(propName, "' at '").concat(componentName, "' component"));
    }
    return null;
  };
}
var isUndefined = function isUndefined(value) {
  return typeof value === 'undefined';
};
var isObject = function isObject(object) {
  return !isUndefined(object) && object != null && _typeof(object) === 'object';
};
export var isEmpty = function isEmpty(object) {
  return isObject(object) && ((object === null || object === void 0 ? void 0 : object.constructor) === Object || (object === null || object === void 0 ? void 0 : object.constructor) === Array) && Object.keys(object).length === 0 || !object;
};
var defaultParamsToQueryStringSerializer = function defaultParamsToQueryStringSerializer(value) {
  return JSON.stringify(value);
};
export var paramsToQueryString = function paramsToQueryString(params) {
  var serialize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultParamsToQueryStringSerializer;
  return Object.keys(params || {}).filter(function (key) {
    return params[key] || params[key] === 0 || params[key] === false;
  }).map(function (key) {
    return [key, typeof params[key] === 'string' ? params[key] : serialize(params[key])];
  }).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return "".concat(key, "=").concat(encodeURIComponent(value));
  }).join('&');
};
export var NOOP = function NOOP() {};
export default {
  isInArray: isInArray
};